import Vue from 'vue'
import App from './App.vue'
import './registerServiceWorker'
import router from './router'
import store from './store'
import dayjs from 'dayjs'
import * as VueGoogleMaps from 'vue2-google-maps'
import Geocoder from '@pderas/vue2-geocoder'

require('./styles/main.sass')

Vue.config.productionTip = false

Vue.prototype.$dayjs = dayjs

Vue.use(VueGoogleMaps, {
    load: {
        key: 'AIzaSyAPL39nYV69x55flQoq_pv7lBp-aWEsV3Q',
        libraries: 'places'
    }
})

Vue.use(Geocoder, {
    defaultCountryCode: 'PL',
    defaultLanguage:    'pl',
    defaultMode:        'address',
    googleMapsApiKey:   'AIzaSyAPL39nYV69x55flQoq_pv7lBp-aWEsV3Q'
})

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
